import { SocialPlatform } from '@/constants/socialPlatforms';

export const getSocialPlatformLink = (key, url) => {
  switch (key) {
    case SocialPlatform.Facebook:
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    case SocialPlatform.LinkedIn:
      return `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
    case SocialPlatform.X:
      return `https://x.com/share?url=${url}`;
  }
};
